import { getContract } from "./core";

export async function getMintPrice() {
  const contract = await getContract();
  return await contract.MINT_PRICE();
}
